import AttributeCondition, {
  ago,
  isBinaryOperator,
  isRelativeTimestampOperator,
  isTwoValueOperator,
  canSelectComparisonOperator,
} from 'cio/app-models/conditions/attribute';
import { SECONDS_IN_DAY } from 'cio/utils/constants';
import { typeOf } from '@ember/utils';
import FormEventAttributeCondition from 'cio/app-models/conditions/form-event-attribute';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import CollectionAttributeCondition from 'cio/app-models/conditions/collection-attribute';
import { SerializedLegacyAttributeFilter } from 'cio/types/conditions/legacy-filter';
import ObjectAttributeCondition from 'cio/app-models/conditions/object-attribute';

export function serializeFilter(
  obj:
    | AttributeCondition
    | EventAttributeCondition
    | FormEventAttributeCondition
    | CollectionAttributeCondition
    | ObjectAttributeCondition,
  useInverse = true,
  addType = false,
  useComparisonOperator = false,
) {
  let { name, operator, comparisonOperator, value } = obj;

  let formType = null;
  if ((obj as FormEventAttributeCondition).formType) {
    formType = (obj as FormEventAttributeCondition).formType;
  }

  if (isRelativeTimestampOperator(operator)) {
    let numValue = Number(obj.timestampValue) * SECONDS_IN_DAY;

    if (obj.timeDirection === ago) {
      numValue = numValue * -1;
    }

    value = numValue.toString();
  } else if (!isBinaryOperator(operator)) {
    value = null;
  }

  let inverse = false;

  if (useInverse && operator.substring(0, 1) === '!') {
    inverse = true;
    operator = operator.substring(1);
  }

  if (typeOf(value) === 'string') {
    value = (value as string).trim();
  }

  if (typeOf(name) === 'string') {
    name = name.trim();
  }

  let filter: SerializedLegacyAttributeFilter = {
    field: name,
    operator,
    value,
  };

  if (useInverse) {
    filter.inverse = inverse;
  }

  if (isTwoValueOperator(operator)) {
    let { value2 } = obj;

    if (typeOf(value2) === 'string') {
      value2 = (value2 as string).trim();
    }

    filter.value2 = value2;
  }

  if (addType) {
    filter.type = 'attribute';
  }

  if (formType) {
    filter.form_type = formType;
  }

  if (obj instanceof ObjectAttributeCondition && obj.objectTypeId != null) {
    filter.type_id = Number(obj.objectTypeId);
  }

  if (useComparisonOperator && canSelectComparisonOperator(operator)) {
    if (comparisonOperator !== 'value') {
      filter = {
        ...filter,
        type: 'attribute_compare',
        field_source: 'customer_attribute',
        value_source: comparisonOperator,
      };
    }
  }

  return filter;
}

export default function (obj: AttributeCondition) {
  let filter = serializeFilter(obj);

  let name = filter.field;

  let and = [
    {
      ...filter,
      field: 'to',
    },
    {
      ...filter,
      field: 'from',
      inverse: !filter.inverse,
    },
  ];

  return {
    event: {
      type: 'attribute_change',
      name,
      filters: { and },
    },
    times: 1,
    within: 0,
    inverse: false,
  };
}
